// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/scripts/project": 0,
	"styles/style": 0,
	"blocks/certified-logos/styles/block": 0,
	"blocks/banner/styles/block": 0,
	"blocks/about-why-pitman/styles/block": 0,
	"styles/editor-style": 0,
	"blocks/why-train/styles/block": 0,
	"blocks/video-lightbox/styles/block": 0,
	"blocks/trustit/styles/block": 0,
	"blocks/training-photos/styles/block": 0,
	"blocks/training-outside-centres/styles/block": 0,
	"blocks/training-introduction/styles/block": 0,
	"blocks/training-how-to-find-us/styles/block": 0,
	"blocks/training-hours-map/styles/block": 0,
	"blocks/training-hero/styles/block": 0,
	"blocks/training-events/styles/block": 0,
	"blocks/training-content-blocks/styles/block": 0,
	"blocks/training-content-blocks-two/styles/block": 0,
	"blocks/training-content-blocks-one/styles/block": 0,
	"blocks/training-centres-outside/styles/block": 0,
	"blocks/training-call-advisor/styles/block": 0,
	"blocks/training-appointments/styles/block": 0,
	"blocks/thank-you-hero/styles/block": 0,
	"blocks/testimonials/styles/block": 0,
	"blocks/team/styles/block": 0,
	"blocks/student-success-stories/styles/block": 0,
	"blocks/seminar-and-workshop/styles/block": 0,
	"blocks/reviews-hero/styles/block": 0,
	"blocks/resource-list/styles/block": 0,
	"blocks/related-courses-table/styles/block": 0,
	"blocks/random-course-list/styles/block": 0,
	"blocks/popular-tabs/styles/block": 0,
	"blocks/popular-courses/styles/block": 0,
	"blocks/our-graduates/styles/block": 0,
	"blocks/our-courses/styles/block": 0,
	"blocks/latest-news/styles/block": 0,
	"blocks/home-hero/styles/block": 0,
	"blocks/global-block/styles/block": 0,
	"blocks/gallery/styles/block": 0,
	"blocks/faq/styles/block": 0,
	"blocks/event-hero/styles/block": 0,
	"blocks/course-salary/styles/block": 0,
	"blocks/course-objectives/styles/block": 0,
	"blocks/course-list/styles/block": 0,
	"blocks/course-intro/styles/block": 0,
	"blocks/course-intro-hours/styles/block": 0,
	"blocks/course-download-form/styles/block": 0,
	"blocks/contact-office/styles/block": 0,
	"blocks/contact-book-request/styles/block": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkgeneratepress_vanadhd"] = self["webpackChunkgeneratepress_vanadhd"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));